var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.0994 6.00986L11.772 1.33715C12.0761 1.03321 12.0761 0.541783 11.772 0.237843C11.468 -0.0660973 10.9766 -0.0660973 10.6727 0.237843L5.99995 4.91055L1.32737 0.237843C1.02329 -0.0660973 0.532003 -0.0660973 0.228062 0.237843C-0.0760208 0.541783 -0.0760208 1.03321 0.228062 1.33715L4.90063 6.00986L0.228062 10.6826C-0.0760208 10.9865 -0.0760208 11.4779 0.228062 11.7819C0.379534 11.9335 0.578697 12.0096 0.777718 12.0096C0.976739 12.0096 1.17576 11.9335 1.32737 11.7819L5.99995 7.10917L10.6727 11.7819C10.8243 11.9335 11.0233 12.0096 11.2223 12.0096C11.4213 12.0096 11.6204 11.9335 11.772 11.7819C12.0761 11.4779 12.0761 10.9865 11.772 10.6826L7.0994 6.00986Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteMessage);
export default __webpack_public_path__ + "static/media/deleteMessage.aadec58293f94800995d23b7f9d1b0ed.svg";
export { ForwardRef as ReactComponent };